import { watch } from 'vue'
import { getUserAction } from '@/api/functions/auth/get-user-action'
import { useQueryApi } from '@/composables/useApi'
import { user as authUser, token } from '@/composables/useAuth'
import { AUTH_PERSISTENT_KEYS } from '@/constants/auth-persistent.constant'

/**
 * Fetch current user
 */
export function useUser() {
  const query = useQueryApi({
    queryKey: ['currentUser'],
    queryFn: async () => {
      const res = await getUserAction() // Adjust endpoint as needed
      return res.data
    },
    enabled: !!token.value,
    initialData: null,
  })

  watch(
    () => query.data.value,
    (newData) => {
      if (newData) {
        authUser.value = newData
        localStorage.setItem(AUTH_PERSISTENT_KEYS.USER, JSON.stringify(newData))
      }
    },
    { immediate: true }
  )

  return {
    ...query,
    user: authUser,
  }
}
